import { useEffect, useRef } from 'react';

import { appHeaderStoreActions } from '@entities/app_header';

const useHeaderScrollControl = () => {
  const lastScrollY = useRef<number>(0);

  const windowScrollHandler = () => {
    const { scrollY = 0 } = window;
    const delta = 15;

    if (Math.abs(lastScrollY.current - scrollY) <= delta) {
      return;
    }

    if (scrollY > lastScrollY.current && lastScrollY.current > 0) {
      appHeaderStoreActions.hideAppHeader();
    } else {
      appHeaderStoreActions.showAppHeader();
    }

    lastScrollY.current = scrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', windowScrollHandler);

    return () => {
      window.removeEventListener('scroll', windowScrollHandler);
    };
  }, []);
};

export default useHeaderScrollControl;
